import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { FaqFormdata, IFaq } from './faq.type';

const FaqApi = createApi({
    reducerPath: "faqApi",
    tagTypes: ["faq"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        addFaq: build.mutation<
            IFaq,
            { slug?: string; data: IFaq }
        >({
            query: ({ slug, data }) => ({
                url: slug ? `faq/${slug}/` : `faq/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["faq"],
        }),
        getFaqs: build.query<PaginationResults<IFaq>, TypeQuery>({
            query: () => `faq/`,
            providesTags: ["faq"],
        }),
        deleteFaq: build.mutation<FaqFormdata, string>({
            query: (slug) => ({
                url: `faq/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["faq"],
        }),
    }),
});

export default FaqApi

export const {
    useAddFaqMutation,
    useGetFaqsQuery,
    useDeleteFaqMutation,
} = FaqApi;